import { convertMicrosecondsToMilliseconds, convertMillisecondsToMicroseconds } from '@dashboard/junk-drawer/utils/time';
import { DateTime } from '@square/dashboard-protos/models/squareup/common/time';
export function convertDateTimeToDate(dateTime) {
  if (!dateTime) {
    return undefined;
  }
  return new Date(convertMicrosecondsToMilliseconds(dateTime.instantUsec));
}
export function convertDateToDateTime(date) {
  return DateTime.create({
    instantUsec: convertMillisecondsToMicroseconds(date.getTime())
  });
}